/* eslint-disable no-shadow */
/* eslint-disable eqeqeq */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { findIndex, values, cloneDeep, orderBy } from 'lodash';
import Datepicker from 'react-datepicker';
import Modal from '../../components/Modal/ReactBootstrapModal';
import Img from '../../components/Img';

import PlayerSelectV2 from '../../components/cards/CardComponents/PlayerSelectV2';
import TeamSelectV2 from '../../components/cards/CardComponents/TeamSelectV2';
import DisplayScoreComponent from '../../components/cards/CardComponents/DisplayScoreV2';
import PopOverMenu from '../../components/PopOverMenu';
import OrderOfPlayModalV2 from './OrderOfPlayModal/OrderOfPlayModalV2';
import ConfirmActionPopup from '../../components/PopUps/ConfirmActionPopup';

import * as drawEditActions from '../../actions/draw-edit-actions';
import * as postScoreActions from '../../actions/post-score-actions';
import * as noticationActions from '../../actions/notification-actions';

import { doesResultAlignWithMatch, PopUpTypes, sortEventOfficialsByRoleThenAlphabetically, isEventType, EventTypes } from '../../utils/events';
import eventsConstants from '../../../constants/events';
import { drawEliminationTypeIds, divisionFormatTypeIds, drawScheduleTypeIds, drawPositionTypeIds, sportTypeIds, groupSmsCodes } from '../../utils/eventConstants';
import { getTypeById, getValueByTypeId, showTagValue } from '../../utils/types';
import PrintMatchSheetModal from './PrintMatchSheetModal';
import { sendGroupSMS } from '../../actions/event-actions';
import { useStatsig } from '../../components/hooks/useStatsig';

const _ = { findIndex, values, cloneDeep, orderBy };

const MatchV2 = (props) => {
    const { isReadOnly, drawId, parentDrawId, match, roundIndex, matchIndex, timeZone, matchPositionNumbers, PTTError, drawEliminationTypeId, drawFormatTypeId, playersDict, playersDictByMemberId, teamsDict, playerOptions, utrType, isPlayerPostDraw, renderTimeSelect, membersInDrawDict, teamsInDrawDict, sportTypeId, scoringTypeId, isDrawPublished } = props;

    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { officials, drawOfficials, matchSheet, orderOfPlay, locations, event } = useSelector(({ drawEdit }) => {
        const { officials, drawOfficials, matchSheet, orderOfPlay, locations, event } = drawEdit;
        return { officials, drawOfficials, matchSheet, orderOfPlay, locations, event };
    });
    const dispatch = useDispatch();
    const { checkGate, featureGates } = useStatsig();
    const isFlexGroupSmsEnabled = checkGate(featureGates.SEND_FLEX_GROUP_SMS);

    const isFlexLeagueEvent = isEventType(event.data, EventTypes.FLEX_LEAGUE);
    const scheduleTypeId = event.data?.scheduleTypeId || drawScheduleTypeIds.MATCH_SHEET;
    const { eventStartUtc, eventEndUtc, maxPostScoreDateUtc } = event.data?.eventSchedule || {};
    const eventTimeZone = timeZone?.value;
    const eventStartLocal = eventTimeZone ? moment.utc(eventStartUtc).tz(eventTimeZone) : moment.utc(eventStartUtc);
    const eventEndLocal = eventTimeZone ? moment.utc(eventEndUtc).tz(eventTimeZone) : moment.utc(eventEndUtc);
    const { formatTypes } = coreUI.types.tms.division;
    const { drawTagTypes } = coreUI.types.tms.draw;
    const { date, detail, groupSMSSent, isTimeBased } = match;
    const dateMoment = date ? moment.utc(date).tz(timeZone.value) : moment.utc(eventStartUtc).tz(timeZone.value).set({ hour: 8, minute: 0 });

    const [showDateModal, setShowDateModal] = useState(false);
    const [showOfficialModal, setShowOfficialModal] = useState(false);
    const [showOrderOfPlayModal, setShowOrderOfPlayModal] = useState(false);
    const [showOfficialDeletePopup, setShowOfficialDeletePopup] = useState(false);
    const [location, setLocation] = useState('');
    const [official, setOfficial] = useState(1);
    const [facilityId, setFacilityId] = useState('');
    const [courtId, setCourtId] = useState('');
    const [matchSheetInfo, setMatchSheetInfo] = useState();
    const [oopInfo, setOopInfo] = useState();
    const [matchOfficials, setMatchOfficials] = useState([]);
    const [allOfficials, setAllOfficials] = useState([]);
    const [showPrintMatchSheetModal, setShowPrintMatchSheetModal] = useState(false);

    const [timeSelect, setTimeSelect] = useState('');
    const [selectedMatchMoment, setSelectedMatchMoment] = useState(match.date ? moment(match.date).utc(true).tz(timeZone.value).local(true) : moment(eventStartUtc));

    const isCourtSchedulerForOrderOfPlayEnabled = checkGate(featureGates.EVENT_DESK_SCHEDULE);
    const disableOrderOfPlayEntryPoints = isCourtSchedulerForOrderOfPlayEnabled;

    useEffect(() => {
        if (isFlexLeagueEvent) {
            dispatch(postScoreActions.setRound({ redirectUrlPage: 'FlexLeagues' }));
        } else {
            dispatch(postScoreActions.setRound({ redirectUrlPage: 'EventDeskPost' }));
        }
    }, []);

    useEffect(() => {
        if (drawOfficials.data !== null) {
            const foundMatch = drawOfficials.data?.find(matchFromDraw => matchFromDraw.id === match.id);
            if (foundMatch) {
                setMatchOfficials([foundMatch.officials[0]]);
            } else {
                setMatchOfficials([]);
            }
        }
    }, [drawOfficials.data]);

    useEffect(() => {
        if (officials.data) {
            const sortedOfficials = sortEventOfficialsByRoleThenAlphabetically(officials.data);

            setAllOfficials(sortedOfficials?.map(officialFromAllOfficials => ({
                id: '',
                status: '',
                official: { ...officialFromAllOfficials },
            })));
        }
    }, [officials.data]);

    useEffect(() => {
        setShowOrderOfPlayModal(false);
        if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY && orderOfPlay.data?.length) {
            const oopIndex = orderOfPlay.data.findIndex(m => m.matchId === match.id);
            if (oopIndex > -1) {
                const oopDataForMatch = orderOfPlay.data[oopIndex];
                setOopInfo(oopDataForMatch);
                setFacilityId(oopDataForMatch.facilityId);
                setCourtId(oopDataForMatch.courtId);
            }
        }
    }, [orderOfPlay.data]);

    useEffect(() => {
        if (scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET && matchSheet.data?.length) {
            const matchSheetIndex = matchSheet.data.findIndex(m => m.matchId === match.id);
            if (matchSheetIndex > -1) {
                setMatchSheetInfo(matchSheet.data[matchSheetIndex]);
                setFacilityId(matchSheet.data[matchSheetIndex].facilityId);
                setCourtId(matchSheet.data[matchSheetIndex].courtId);
            }
        }
    }, [matchSheet.data]);

    const handlePlayerSelect = (position, player) => {
        props.playerSelect({ roundIndex, matchId: match.id, position, player });
    };

    const handleScorePopoverClick = (item) => {
        dispatch(drawEditActions.setResetTimer(true));
        if (item.value === 'edit') {
            props.handlePostScore(roundIndex, matchIndex);
        } else if (item.value === 'clear') {
            clearScore();
        } else if (item.value === 'time_location') {
            handleDateClick();
        } else if (item.value === 'add_official') {
            setShowOfficialModal(true);
        } else if (item.value === 'remove_official') {
            setShowOfficialDeletePopup(true);
        } else if (item.value === eventsConstants.ORDER_OF_PLAY) {
            if (!disableOrderOfPlayEntryPoints) {
                // Users should use court scheduler for Order of Play if enabled. disabling this entry point
                setShowOrderOfPlayModal(true);
            }
        } else if (item.value === 'remove_oop_match') {
            removeMatchFromSchedule('orderOfPlay');
        } else if (item.value === 'remove_match_sheet') {
            removeMatchFromSchedule('matchSheet');
        }
    };

    // show match modal
    const handleDateClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        const { date } = match;
        setTimeSelect('');
        // eslint-disable-next-line newline-per-chained-call
        setSelectedMatchMoment(date ? moment(date).utc(true).tz(timeZone.value).local(true) : moment(eventStartUtc).utc(true).tz(timeZone.value).local(true).set({ hour: 8, minute: 0 }));
        setLocation(match.detail || '');
        if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY) {
            if (!disableOrderOfPlayEntryPoints) {
                // Users should use court scheduler for Order of Play if enabled. disabling this entry point
                setShowOrderOfPlayModal(true);
            }
        } else {
            setShowDateModal(true);
        }
    };

    const closeModals = () => {
        setShowDateModal(false);
        setShowOfficialModal(false);
        setShowOrderOfPlayModal(false);
        setShowPrintMatchSheetModal(false);
    };

    const handleMatchDateChange = (value) => {
        dispatch(drawEditActions.setResetTimer(true));
        const timeVal = timeSelect;
        const time = timeVal.split(':');
        const date = value.clone();
        date.set({ hour: time[0], minute: time[1], second: 0 });
        setSelectedMatchMoment(date);
    };

    const handleMatchTimeChange = (timeVal) => {
        const time = timeVal.split(':');
        const newDateObj = selectedMatchMoment?.clone() || moment();
        newDateObj.set({ hour: time[0], minute: time[1], second: 0 });
        setSelectedMatchMoment(newDateObj);
        setTimeSelect(timeVal);
    };

    const handleMatchLocationChange = (e) => {
        dispatch(drawEditActions.setResetTimer(true));
        e.persist();
        setLocation(e.target.value);
    };

    const updateMatchDateTime = () => {
        dispatch(drawEditActions.setResetTimer(true));
        const newDate = moment(selectedMatchMoment).tz(timeZone.value, true).utc().format('YYYY-MM-DDTHH:mm:ss');
        if (scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET) {
            dispatch(drawEditActions.updateMatchSheet({
                matchId: match.id,
                payload: {
                    date: newDate,
                    facilityId: (facilityId === '' ? null : facilityId),
                    courtId: (courtId === '' ? null : courtId),
                },
            }));
        }
        setShowDateModal(false);
    };

    const clearScore = async () => {
        dispatch(drawEditActions.setResetTimer(true));
        try {
            await dispatch(drawEditActions.clearScore(match));
        } catch (err) {
            console.log(err);
        }
    };

    const clearMatchData = () => {
        setOopInfo('');
        setMatchSheetInfo('');
        setFacilityId('');
        setCourtId('');
    };

    const removeMatchFromSchedule = async (type) => {
        dispatch(drawEditActions.setResetTimer(true));
        if (type === 'orderOfPlay') {
            await dispatch(drawEditActions.deleteOrderOfPlay(event.data?.id, match.id));
        } else {
            await dispatch(drawEditActions.removeMatchSheet(match.id));
        }
        clearMatchData();
    };

    const handleOfficialChange = (e) => {
        setOfficial(e.target.value);
    };

    const updateMatchOfficial = () => {
        dispatch(drawEditActions.setResetTimer(true));
        const newOfficial = allOfficials[official];
        dispatch(drawEditActions.addMatchOfficial({
            drawId,
            matchId: match.id,
            payload: {
                officialIds: [newOfficial.official.id],
            },
        }));
        setShowOfficialModal(false);
    };

    const removeMatchOfficial = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.deleteMatchOfficial({
            drawId,
            matchId: match.id,
            payload: matchOfficials[0]?.id,
        }));
        setShowOfficialDeletePopup(false);
    };

    const handleFacilityChange = (e) => {
        dispatch(drawEditActions.setResetTimer(true));
        setFacilityId(e.target.value);
        setCourtId(''); // reset court if facility is changed
    };

    const handleCourtChange = (e) => {
        dispatch(drawEditActions.setResetTimer(true));
        setCourtId(e.target.value);
    };

    const renderOfficialName = (off) => {
        if (off) {
            const { eventOfficialRolesTypes } = coreUI.types.tms;
            const { countries } = coreUI.types.search;
            const countryCode = countries.find(c => c.id === off.official.countryId)?.label;
            const role = eventOfficialRolesTypes.find(r => r.value === off.official.role)?.label;
            return `${countryCode} ${off.official.firstName[0]}. ${off.official.lastName}, ${role}`;
        }
        return '';
    };

    const showSmsPopUp = () => {
        if (isDrawPublished) {
            dispatch(noticationActions.showInfoPopup({
                title: 'Please Confirm',
                message: 'Are you sure you want to send the opponent group SMS texts to this matchup?',
                confirmButtonLabel: 'Send',
                onConfirmClick: onSendSmsConfirmClick,
                showCancelButton: true,
            }));
        }
    };

    const onSendSmsConfirmClick = () => {
        dispatch(sendGroupSMS(event.data.id, { matchIds: [match.id] }, drawId));
    };

    let locationDisplay = detail;
    let locationName;
    let facilityName;
    let courtName;
    let infoObj;
    if (scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET && matchSheetInfo) {
        infoObj = matchSheetInfo;
    } else if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY && oopInfo) {
        infoObj = oopInfo;
    }
    if (infoObj) {
        locationDisplay = null;
        if (infoObj.locationId || infoObj.facilityId || infoObj.courtId) {
            (locations.data || []).forEach(loc => {
                if (loc.id === infoObj.locationId) {
                    locationName = loc.name;
                    loc.facilities.forEach(fac => {
                        if (fac.id === infoObj.facilityId) {
                            facilityName = fac.abbreviation || fac.name;
                            fac.courts.forEach(c => {
                                if (c.id === infoObj.courtId) {
                                    courtName = c.name;
                                }
                            });
                        }
                    });
                }
            });
            if (!locationName) {
                locationDisplay = 'Loading...';
            } else {
                locationDisplay = [locationName, facilityName, courtName].filter(Boolean).join(', ');
            }
        }
    }
    const hasBye = match.position1?.typeId === drawPositionTypeIds.BYE || match.position2?.typeId === drawPositionTypeIds.BYE;
    const hasResult = !!match.result;
    const playerPostedScore = hasResult && match.result?.playerPostedResult;
    const hasBothPlayers = match.position1 && match.position1?.typeId !== drawPositionTypeIds.BYE && match.position2 && match.position2?.typeId !== drawPositionTypeIds.BYE;
    const hasError = !doesResultAlignWithMatch(match, playersDict, teamsDict, playersDictByMemberId);
    const showByeOption = drawEliminationTypeId !== drawEliminationTypeIds.MATCH_PLAY;
    let canAddEditScore = !playerPostedScore;
    if (hasResult && isPlayerPostDraw && _.findIndex(_.values(match.result.players), { memberId: match.result.submittingMemberId }) !== -1) {
        canAddEditScore = false;
    }
    if (maxPostScoreDateUtc) {
        if (moment.utc().isAfter(moment(maxPostScoreDateUtc))) {
            canAddEditScore = false;
        }
    }

    const showScoreEdit = (((match.position1 && match.position1.typeId !== drawPositionTypeIds.BYE && match.position2 && match.position2.typeId !== drawPositionTypeIds.BYE) && match.result !== null) || hasError) && canAddEditScore;
    const matchOfficial = matchOfficials[0];

    const popoverMenuItems = [];

    if (!showScoreEdit) {
        if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY) {
            if (!disableOrderOfPlayEntryPoints) {
                // Users should use court scheduler for Order of Play if enabled. removing these options
                popoverMenuItems.push({ value: eventsConstants.ORDER_OF_PLAY, label: 'Order of Play' });
                const orderOfPlayIndex = orderOfPlay.data?.findIndex((oopObj) => oopObj?.matchId === match.id);
                if (orderOfPlayIndex > -1) { popoverMenuItems.push({ value: 'remove_oop_match', label: 'Remove from Order of Play' }); }
            }
        } else {
            if (scheduleTypeId !== drawScheduleTypeIds.NEXT_AVAILABLE && scheduleTypeId !== drawScheduleTypeIds.ORDER_OF_PLAY) {
                popoverMenuItems.push({ value: 'time_location', label: 'Set Time and Location' });
            }
            const matchSheetIndex = matchSheet.data?.findIndex(m => m.matchId === match.id);
            if (matchSheetIndex > -1) { popoverMenuItems.push({ value: 'remove_match_sheet', label: 'Remove from Match Schedule' }); }
        }
    }

    if (showScoreEdit) {
        if (!hasError) {
            popoverMenuItems.push({ value: 'edit', label: 'Edit Score' });
        }
        popoverMenuItems.push({ value: 'clear', label: 'Clear Score' });
    }

    if (officials.data?.length) {
        if (matchOfficial) {
            popoverMenuItems.push({ value: 'remove_official', label: 'Remove Official' });
        } else {
            popoverMenuItems.push({ value: 'add_official', label: 'Add Official' });
        }
    }

    const renderLocationFacilityList = () => {
        const facilityList = [];
        (locations.data || []).forEach(loc => {
            loc.facilities.forEach(fac => {
                if (fac.courts.some(c => c.enabled)) {
                    facilityList.push({
                        label: `${loc.name} - ${fac.abbreviation}`,
                        value: fac.id,
                    });
                }
            });
        });
        return _.orderBy(facilityList, [f => f.label?.toLowerCase()]);
    };
    const renderFacilityCourts = () => {
        const courts = [];
        (locations.data || []).forEach(loc => {
            loc.facilities.forEach(fac => {
                if (fac.id === facilityId) {
                    // eslint-disable-next-line prefer-destructuring
                    fac.courts.forEach(c => {
                        if (c.enabled) {
                            courts.push(c);
                        }
                    });
                }
            });
        });
        return _.orderBy(courts, [c => c.name?.toLowerCase()]);
    };

    const eventEndDate = moment.utc(event?.eventSchedule?.eventEndUtc).tz(timeZone.value);

    const getPlayerTag = (position) => {
        let tag;
        if (match[position]?.typeId === drawPositionTypeIds.PLAYER) {
            const drawPlayerObject = membersInDrawDict[match[position].memberId];
            if (showTagValue(drawPlayerObject?.tagId)) {
                tag = getValueByTypeId(drawTagTypes, drawPlayerObject.tagId);
            }
        } else if (match[position]?.typeId === drawPositionTypeIds.TEAM) {
            const drawTeamObject = teamsInDrawDict[match[position].teamId];
            if (showTagValue(drawTeamObject?.tagId)) {
                tag = getValueByTypeId(drawTagTypes, drawTeamObject.tagId);
            }
        }
        return tag || <>&nbsp;</>;
    };

    const isPickleballEvent = event.data?.sportTypeId === sportTypeIds.PICKLEBALL;

    const showPrintPopUp = () => {
        setShowPrintMatchSheetModal(true);
    };

    const printMatchSheet = (matchId, formValues) => {
        // Call update draws/match API for saving isPrinted
        if (formValues.markPrinted) {
            dispatch(drawEditActions.printMatchSheet({ reload: true, matchId }));
        }
        setShowPrintMatchSheetModal(false);
        // Redirect to matchsheet print page with above matchId and formValues
        const eventId = event.data?.id;
        const { scoreSheetType, pageFormat } = formValues;
        if (window) {
            window.open(`/events/${eventId}/draws/${drawId}/print-matches?matchId=${matchId}&scoringFormat=${scoringTypeId}&scoreSheetType=${scoreSheetType}&pageFormat=${pageFormat}`, '_blank');
        } else {
            props.history.push(`/events/${eventId}/draws/${drawId}/print-matches?matchId=${matchId}&scoringFormat=${scoringTypeId}&scoreSheetType=${scoreSheetType}&pageFormat=${pageFormat}`);
        }
    };

    const displaySetDateTime = useMemo(() => {
        if (scheduleTypeId === drawScheduleTypeIds.ORDER_OF_PLAY) {
            return !disableOrderOfPlayEntryPoints;
        }

        return scheduleTypeId !== drawScheduleTypeIds.NEXT_AVAILABLE;
    }, [scheduleTypeId, disableOrderOfPlayEntryPoints]);

    return (
        <>
            <div className={`draw-card ${hasResult ? 'has-score' : 'no-score'} ${hasError ? 'has-error' : ''}`} data-testid={`draw-edit.match-${match.id}`}>
                <div className="header">
                    {hasBye && (
                        <div className="mb0 d-flex aic">
                            <span className="ml-auto" data-testid={`draw-edit.match-${match.id}.match-position`}>Match #{match.matchPosition}{hasResult && ' - Played'}</span>
                        </div>
                    )}
                    {!hasBye && (
                        <div className="mb0 d-flex aic">
                            {isReadOnly && (
                                dateMoment.format('ddd, MMM Do') || <>&nbsp;</>
                            )}
                            {!isReadOnly && (
                                <>
                                    {date && (
                                        <>
                                            <u className="cursor-pointer" onClick={() => canAddEditScore && handleDateClick()} data-testid={`draw-edit.match-${match.id}.date-link`}>{dateMoment.format('ddd, MMM Do')}</u> {(oopInfo?.includesTime || scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET) && <><div className="d-inline-block mr4 ml4"> at </div><u className="cursor-pointer" onClick={() => canAddEditScore && handleDateClick()} data-testid={`draw-edit.match-${match.id}.time-link`}>{dateMoment.format('h:mma')}</u></>}
                                            {isTimeBased && (
                                                <div className="vertical-separator ml8 mr4">&nbsp;</div>
                                            )}
                                        </>
                                    )}
                                    {!date && displaySetDateTime && (
                                        <>
                                            <u className="cursor-pointer" onClick={() => canAddEditScore && handleDateClick()} data-testid={`draw-edit.match-${match.id}.set-date-btn`}>Set Date & Time</u>
                                            {isTimeBased && (
                                                <div className="vertical-separator ml8 mr4">&nbsp;</div>
                                            )}
                                        </>
                                    )}
                                    {isTimeBased && (
                                        <Img
                                            src="/img/v4/icon-clock.svg"
                                            title="This match uses timed based scoring"
                                        />
                                    )}
                                    <span className="ml-auto" data-testid={`draw-edit.match-${match.id}.match-position`}>Match #{match.matchPosition}{hasResult && ' - Played'}</span>
                                </>
                            )}
                        </div>
                    )}
                    {isReadOnly ? (
                        <>
                            {locationDisplay}
                        </>
                    ) : (
                        <>
                            {locationDisplay || <>&nbsp;</> ? (
                                <div className="mb0">
                                    <i className="uts uts-location" />
                                    <div
                                        className="cursor-pointer ellipsis ul"
                                        title={locationDisplay}
                                        onClick={() => canAddEditScore && handleDateClick()}
                                        data-testid={`draw-edit.match-${match.id}.location-link`}
                                    >
                                        {locationDisplay}
                                    </div>
                                </div>
                            ) : (
                                <div className="mb0">
                                    <i className="uts uts-location" />
                                    <div
                                        className="cursor-pointer ellipsis ul"
                                        onClick={() => canAddEditScore && handleDateClick()}
                                        data-testid={`draw-edit.match-${match.id}.set-location-btn`}
                                    >
                                        Set Location
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="content">
                    {drawFormatTypeId === divisionFormatTypeIds.SINGLES ? (
                        <div className="players-wrapper">
                            <div className="tag-container fs10" data-testid={`draw-edit.match-${match.id}.tag-position1`}>{getPlayerTag('position1')}</div>
                            <PlayerSelectV2
                                {...props}
                                position="position1"
                                key="position1"
                                onSelect={handlePlayerSelect}
                                isReadOnly={hasResult || isReadOnly}
                                showBye={showByeOption}
                                PTTPosition={matchPositionNumbers?.[0]}
                                PTTError={PTTError && PTTError.memberId == match.position1?.memberId && PTTError.positionNumber == matchPositionNumbers?.[0]}
                                doNotMask={false}
                                drawFormatType={getTypeById(formatTypes, drawFormatTypeId)}
                                sportTypeId={sportTypeId}
                                drawId={drawId}
                                parentDrawId={parentDrawId}
                                data-testid={`draw-edit.match-${match.id}.position1-select`}
                            />
                            <PlayerSelectV2
                                {...props}
                                position="position2"
                                key="position2"
                                onSelect={handlePlayerSelect}
                                isReadOnly={hasResult || isReadOnly}
                                showBye={showByeOption}
                                PTTPosition={matchPositionNumbers?.[1]}
                                PTTError={PTTError && PTTError?.memberId == match.position2?.memberId && PTTError.positionNumber == matchPositionNumbers?.[1]}
                                doNotMask={false}
                                drawFormatType={getTypeById(formatTypes, drawFormatTypeId)}
                                sportTypeId={sportTypeId}
                                drawId={drawId}
                                parentDrawId={parentDrawId}
                                data-testid={`draw-edit.match-${match.id}.position2-select`}
                            />
                            <div className="tag-container fs10" data-testid={`draw-edit.match-${match.id}.tag-position2`}>{getPlayerTag('position2')}</div>
                        </div>
                    ) : (
                        <div className="players-wrapper">
                            <div className="tag-container fs10" data-testid={`draw-edit.match-${match.id}.tag-position1`}>{getPlayerTag('position1')}</div>
                            <TeamSelectV2
                                position="position1"
                                key="position1"
                                onSelect={handlePlayerSelect}
                                isReadOnly={hasResult || isReadOnly}
                                showBye={showByeOption}
                                drawFormatType={getTypeById(formatTypes, drawFormatTypeId)}
                                match={match}
                                playerOptions={playerOptions}
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                utrType={utrType} // value
                                PTTPosition={matchPositionNumbers?.[0]}
                                PTTError={PTTError && PTTError?.memberId == match.position1?.memberId && PTTError?.positionNumber == matchPositionNumbers?.[0]}
                                doNotMask={false}
                                sportTypeId={sportTypeId}
                                drawId={drawId}
                                parentDrawId={parentDrawId}
                                data-testid={`draw-edit.match-${match.id}.position1-select`}
                            />
                            <TeamSelectV2
                                position="position2"
                                key="position2"
                                onSelect={handlePlayerSelect}
                                isReadOnly={hasResult || isReadOnly}
                                showBye={showByeOption}
                                drawFormatType={getTypeById(formatTypes, drawFormatTypeId)}
                                match={match}
                                playerOptions={playerOptions}
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                utrType={utrType} // value
                                PTTPosition={matchPositionNumbers?.[1]}
                                PTTError={PTTError && PTTError?.memberId == match.position2?.memberId && PTTError?.positionNumber == matchPositionNumbers?.[1]}
                                doNotMask={false}
                                sportTypeId={sportTypeId}
                                drawId={drawId}
                                parentDrawId={parentDrawId}
                                data-testid={`draw-edit.match-${match.id}.position2-select`}
                            />
                            <div className="tag-container fs10" data-testid={`draw-edit.match-${match.id}.tag-position2`}>{getPlayerTag('position2')}</div>
                        </div>
                    )}
                    <div className="score-wrapper">
                        {hasResult ? (
                            <>
                                <DisplayScoreComponent match={match} position="position1" playersDictByMemberId={playersDictByMemberId} teamsDict={teamsDict} />
                                <DisplayScoreComponent match={match} position="position2" playersDictByMemberId={playersDictByMemberId} teamsDict={teamsDict} />
                            </>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-default btn-small"
                                disabled={hasBye || !hasBothPlayers || !canAddEditScore}
                                onClick={() => props.handlePostScore(roundIndex, matchIndex)}
                                data-testid={`draw-edit.match-${match.id}.score-btn`}
                            >
                                Score
                            </button>
                        )}
                    </div>
                </div>
                <div className="footer">
                    {matchOfficial ? (
                        <div className="link" onClick={() => setShowOfficialDeletePopup(true)} data-testid={`draw-edit.match-${match.id}.official-link`}>
                            {renderOfficialName(matchOfficial)}
                        </div>
                    ) : (
                        <div />
                    )}
                    {isPickleballEvent && (
                        <>
                            <div className="popover-wrapper" onClick={showPrintPopUp} data-testid={`draw-edit.match-${match.id}.print-btn`}>
                                <Img className="print-icon" src="/img/v3/icons/icon-print.svg" />
                            </div>
                            {match.isPrinted && (
                                <div className="popover-wrapper" data-testid={`draw-edit.match-${match.id}.printed-label`}>Printed</div>
                            )}
                        </>
                    )}
                    {isFlexLeagueEvent && !hasBye && isFlexGroupSmsEnabled && (
                        <>
                            <div className="popover-wrapper" data-testid={`draw-edit.match-${match.id}.sms-btn`}>
                                <Img className="print-icon" src={`/img/v4/icon-sms${!isDrawPublished ? '-disabled' : ''}.svg`} onClick={showSmsPopUp} />
                            </div>
                            {groupSMSSent === groupSmsCodes.SUCCESS && (
                                <div className="popover-wrapper text-success fs12 d-flex aic" data-testid={`draw-edit.match-${match.id}.sms-success`}>
                                    <Img className="mr4" src="/img/v4/circle-check-green.svg" /> Group text sent
                                </div>
                            )}
                            {groupSMSSent === groupSmsCodes.FAILED && (
                                <div className="popover-wrapper text-error fs12 d-flex aic" data-testid={`draw-edit.match-${match.id}.sms-error`}>
                                    <Img className="mr4" src="/img/v4/triangle-exclamation-red.svg" /> Group text failed
                                </div>
                            )}
                        </>
                    )}
                    {!isReadOnly && popoverMenuItems?.length > 0 && (
                        <div className="popover-wrapper">
                            <PopOverMenu
                                popOverMenuClass="float-right"
                                horizontalEllipsis={true}
                                menuItems={popoverMenuItems}
                                onSelected={handleScorePopoverClick}
                                data-testid={`draw-edit.match-${match.id}.menu`}
                            />
                        </div>
                    )}
                </div>
            </div>
            {showDateModal && (
                <Modal visible={true} onClickBackdrop={closeModals}>
                    <div className="modal-header">
                        <div className="text-medium" data-testid="modal.draw-edit.change-match.title">Change Match</div>
                        <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.change-match.close-btn"><i className="utr utr-close" /></div>
                    </div>
                    <div className="modal-body">
                        {selectedMatchMoment && (
                            <div className={`form-group form-group-xl`}>
                                <label>Date & Time</label>
                                <div className="row">
                                    <div className="col-7 pr4">
                                        <div className="input-wrapper">
                                            <Datepicker
                                                className="form-control"
                                                selected={moment(selectedMatchMoment)}
                                                onChange={handleMatchDateChange}
                                                minDate={eventStartLocal}
                                                maxDate={eventEndLocal}

                                            />
                                        </div>
                                    </div>
                                    <div className="col-5 pl0">
                                        <div className="input-wrapper">
                                            {renderTimeSelect(moment(selectedMatchMoment), handleMatchTimeChange, 'modal.draw-edit.change-match.time-select')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className={`form-group form-group-xl`}>
                            {scheduleTypeId === drawScheduleTypeIds.MATCH_SHEET ? (
                                <>
                                    <label>Location</label>
                                    <div className="row">
                                        <div className="col-6 pr4">
                                            <div className="input-wrapper">
                                                <select className="form-control" value={facilityId} onChange={handleFacilityChange} data-testid="modal.draw-edit.change-match.facility-select">
                                                    <option value={''}>{locations.loading ? 'Loading...' : 'Choose location...'}</option>
                                                    {renderLocationFacilityList().map(fac => (
                                                        <option value={fac.value}>{fac.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-6 pl0">
                                            <div className="input-wrapper">
                                                <select className="form-control" value={courtId} onChange={handleCourtChange} data-testid="modal.draw-edit.change-match.court-select">
                                                    <option value={''}>{locations.loading ? 'Loading...' : 'Choose court...'}</option>
                                                    {renderFacilityCourts().map(c => (
                                                        <option value={c.id}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <label>Location</label>
                                    <div className="input-wrapper">
                                        <input type="text" className="form-control" value={location} onChange={handleMatchLocationChange} data-testid="modal.draw-edit.change-match.location-input" />
                                    </div>
                                </>
                            )}
                        </div>
                        <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={updateMatchDateTime} data-testid="modal.draw-edit.change-match.ok-btn">OK</button>
                    </div>
                </Modal>
            )}
            {showOfficialModal && (
                <Modal visible={true} onClickBackdrop={closeModals}>
                    <div className="modal-header">
                        <div className="text-medium" data-testid="modal.draw-edit.add-official.title">Add Official to Match</div>
                        <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.add-official.close-btn"><i className="utr utr-close" /></div>
                    </div>
                    <div className="modal-body">
                        <div className={`form-group form-group-xl`}>
                            <label>Official</label>
                            <div className="input-wrapper">
                                <select
                                    className="form-control"
                                    value={official}
                                    onChange={handleOfficialChange}
                                    data-testid="modal.draw-edit.add-official.official-select"
                                >
                                    <option>Choose official...</option>
                                    {allOfficials.map((off, i) => (
                                        <option value={i}>{renderOfficialName(off)}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={updateMatchOfficial} data-testid="modal.draw-edit.add-official.ok-btn">OK</button>
                    </div>
                </Modal>
            )}
            {showOrderOfPlayModal && (
                <OrderOfPlayModalV2
                    match={match}
                    oopInfo={oopInfo}
                    closeModals={closeModals}
                    drawId={drawId}
                    event={event}
                    timeZone={timeZone}
                    setShowDateModal={setShowDateModal}
                    setShowOrderOfPlayModal={setShowOrderOfPlayModal}
                    maxMatchDate={eventEndDate}
                    drawFormatType={getTypeById(formatTypes, drawFormatTypeId)}
                    teamsDict={teamsDict}
                    playersDictByMemberId={playersDictByMemberId}
                />
            )}
            {showOfficialDeletePopup && (
                <ConfirmActionPopup
                    onCloseClick={() => {
                        setShowOfficialDeletePopup(false);
                    }}
                    onCtaClick={removeMatchOfficial}
                    confirmationTitle="Remove Official"
                    confirmationMessage={PopUpTypes.REMOVE_MATCH_OFFICIAL.message}
                    data-testid="modal.draw-edit.remove-match-official"
                />
            )}
            {showPrintMatchSheetModal && (
                <PrintMatchSheetModal
                    matchId={match.id}
                    printMatchSheet={printMatchSheet}
                    closeModals={closeModals}
                />
            )}
        </>
    );
};

MatchV2.propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
    drawId: PropTypes.string.isRequired,
    parentDrawId: PropTypes.string.isRequired,
    match: PropTypes.objectOf(any).isRequired,
    roundIndex: PropTypes.number.isRequired,
    matchIndex: PropTypes.number.isRequired,
    timeZone: PropTypes.objectOf(any).isRequired,
    matchPositionNumbers: PropTypes.arrayOf(PropTypes.number),
    PTTError: PropTypes.objectOf(any),
    drawEliminationTypeId: PropTypes.number.isRequired,
    drawFormatTypeId: PropTypes.number.isRequired,
    playersDict: PropTypes.objectOf(any).isRequired,
    playersDictByMemberId: PropTypes.objectOf(any).isRequired,
    teamsDict: PropTypes.objectOf(any).isRequired,
    playerOptions: PropTypes.objectOf(any).isRequired,
    utrType: PropTypes.string.isRequired,
    isPlayerPostDraw: PropTypes.bool.isRequired,
    renderTimeSelect: PropTypes.func.isRequired,
    membersInDrawDict: PropTypes.objectOf(any),
    teamsInDrawDict: PropTypes.objectOf(any),
    sportTypeId: PropTypes.number.isRequired,
    scoringTypeId: PropTypes.number.isRequired,
    history: PropTypes.objectOf(any),
    isDrawPublished: PropTypes.bool,
};

MatchV2.defaultProps = {
    membersInDrawDict: {},
    teamsInDrawDict: {},
    history: {},
    matchPositionNumbers: null,
    PTTError: null,
    isDrawPublished: false,
};

export default React.memo(MatchV2);
